module.exports = __webpack_public_path__ + "static/media/CNews5.bdb14b81.png";